import { Bar, BarChart, CartesianGrid, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts"
import { GroupSummary } from "models/opportunity-dashboard"
import { money } from "./format"

interface GroupBarChartProps {
    title: string
    data: GroupSummary[]
    color?: string
}

// "1.3M" / "0.2M" bar labels, like the Power BI report.
const millions = (v: number) => `${(v / 1_000_000).toFixed(1)}M`

// Columns of value per group (division), labelled in millions.
const GroupBarChart = ({ title, data, color = "var(--bs-primary)" }: GroupBarChartProps) => (
    <div className="section-container">
        <h5 className="mb-3">{title}</h5>
        {data.length === 0
            ? <p className="text-muted mb-0">No opportunities.</p>
            : <div style={{ width: "100%", height: 240 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={data} margin={{ top: 24, left: 0, right: 10 }}>
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <XAxis dataKey="name" tick={{ fontSize: 12 }} interval={0} />
                        <YAxis tickFormatter={millions} width={50} />
                        <Tooltip
                            formatter={(v: number) => money(v)}
                            labelFormatter={(label: string) => {
                                const row = data.find(d => d.name === label)
                                return row ? `${label} (${row.count})` : label
                            }}
                        />
                        <Bar dataKey="value" name="Value" fill={color} maxBarSize={120}>
                            <LabelList dataKey="value" position="top" formatter={millions} />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </div>}
    </div>
)

export default GroupBarChart
